import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { siteLogo as logo } from "../../../../const";
import { sendOtp, sendVerifyOtp } from "../../../../reducers/commonReducer";
import { chatUsers, quickChat, userprofile } from "../../../../const";

const RESEND_COOLDOWN = 30;

const schema = yup.object().shape({
  phone: yup.string().required(),
  otp: yup.string().required(),
  agreedToTerms: yup.bool().oneOf([true]),
});

const VerifyOtp = () => {
  let width = window.innerWidth;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(RESEND_COOLDOWN);
  const [resendMsg, setResendMsg] = useState("");
  const cooldownRef = useRef(null);

  const startCooldown = () => {
    setResendCooldown(RESEND_COOLDOWN);
    clearInterval(cooldownRef.current);
    cooldownRef.current = setInterval(() => {
      setResendCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(cooldownRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    startCooldown();
    localStorage.removeItem("sendVerificationCode");
    return () => clearInterval(cooldownRef.current);
  }, []);

  const handleResend = async () => {
    const phone = localStorage.getItem("phone");
    if (!phone || resendCooldown > 0) return;
    setResendLoading(true);
    setResendMsg("");
    try {
      const resp = await dispatch(sendOtp({ phone }));
      if (resp?.payload?.status) {
        setResendMsg("OTP sent successfully.");
        startCooldown();
      } else {
        setResendMsg(resp?.payload?.message || "Failed to resend OTP.");
      }
    } catch {
      setResendMsg("Failed to resend OTP.");
    } finally {
      setResendLoading(false);
    }
  };

  const persistLoggedInUser = (payload) => {
    localStorage.setItem("x-auth-token", payload?.token || "");
    localStorage.setItem("userid", payload?.user?.id || "");
    localStorage.setItem("slug", payload?.user?.role?.slug || "");
    localStorage.setItem("userRole", payload?.user?.role?.name || "");
    localStorage.setItem("username", payload?.user?.email || payload?.user?.phone || "");
    localStorage.setItem("branch", payload?.user?.branch?.id || "");
    localStorage.setItem("branchName", payload?.user?.branch?.name || "");
  };
  return (
    <>
      {/* <CommonHeader /> */}
      <div className="container-fluid">
        <div className="p-5 mbl-pedding-10">
          <Row>
            <Col md={12} className="text-center">
              <img className={`${width > 468 ? `w-10` : `w-50`}`} style={{ objectFit: "contain" }} src={logo} alt={process.env.REACT_APP_SITE_NAME} />
            </Col>
          </Row>
          <Row className="justify-content-between mb-40">
            <Col md={12} className="text-center">
              <h1>Verify your Phone</h1>
              <p>Enter the OTP sent to your number</p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="m-auto">
              <Formik
                validationSchema={schema}
                onSubmit={async (values) => {
                  setLoading(true);
                  const apiresp = await dispatch(sendVerifyOtp(values));
                  if(apiresp?.payload?.status && apiresp?.payload?.new === 1){
                    persistLoggedInUser(apiresp?.payload);
                    setLoading(false);
                    await navigate(userprofile);
                  }else if(apiresp?.payload?.status && apiresp?.payload?.new === 0){
                    persistLoggedInUser(apiresp?.payload);
                    setLoading(false);
                    await navigate(chatUsers); 
                    window.location.reload();
                    // if(apiresp?.payload?.user?.role?.slug === "customer"){
                    //   await navigate(chatUsers); 
                    // }else{
                    //   await navigate(chatUsers); 
                    // }
                  }else{
                    setLoading(false);
                  }
                }}
                initialValues={{
                  phone: localStorage.getItem("phone"),
                  otp: "",
                  agreedToTerms: false,
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3 mt-4">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <Form.Control
                            type="text"
                            placeholder="Please Enter OTP"
                            name="otp"
                            value={values.otp}
                            onChange={handleChange}
                            isInvalid={!!errors.otp}
                            className={errors.otp && touched.otp && "errors"}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.otp}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <div
                          className="d-flex align-items-center gap-2 p-3 rounded mb-3"
                          style={{ background: "#f5f0c8" }}
                        >
                          <Form.Check
                            type="checkbox"
                            id="agreedToTerms"
                            name="agreedToTerms"
                            checked={values.agreedToTerms}
                            onChange={handleChange}
                            style={{ width: 20, height: 20, minWidth: 20, cursor: "pointer" }}
                          />
                          <Form.Label htmlFor="agreedToTerms" className="mb-0" style={{ fontSize: 13, cursor: "pointer" }}>
                            By proceeding, you agree to our{" "}
                            <Link to="/term-and-conditions" target="_blank" style={{ fontWeight: 700, color: "inherit" }}>
                              Terms &amp; Conditions
                            </Link>{" "}
                            and{" "}
                            <Link to="/privacy-policy-ios-app" target="_blank" style={{ fontWeight: 700, color: "inherit" }}>
                              Privacy Policy
                            </Link>
                            .
                          </Form.Label>
                        </div>
                        <Button
                          variant="success"
                          className="bg-thememain w-100 text-black"
                          type="submit"
                          disabled={!values.agreedToTerms || loading}
                        >
                          {loading ? <Spinner animation="grow" /> : `Verify OTP`}
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} sm={12} className="text-center mt-1">
                        {resendCooldown > 0 ? (
                          <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                            Resend OTP in <b>{resendCooldown}s</b>
                          </p>
                        ) : (
                          <p className="mb-0" style={{ fontSize: 14 }}>
                            Didn't receive the OTP?{" "}
                            <span
                              className="theme-link fw-bold"
                              style={{ cursor: "pointer" }}
                              onClick={handleResend}
                            >
                              {resendLoading ? "Sending…" : "Resend OTP"}
                            </span>
                          </p>
                        )}
                        {resendMsg && (
                          <p className={`mt-1 mb-0`} style={{ fontSize: 13, color: resendMsg.includes("success") ? "green" : "red" }}>
                            {resendMsg}
                          </p>
                        )}
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default VerifyOtp;
